import { render, staticRenderFns } from "./ShiftHoursTab.vue?vue&type=template&id=19ae858e&scoped=true"
import script from "./ShiftHoursTab.vue?vue&type=script&lang=js"
export * from "./ShiftHoursTab.vue?vue&type=script&lang=js"
import style0 from "./ShiftHoursTab.vue?vue&type=style&index=0&id=19ae858e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ae858e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ae858e')) {
      api.createRecord('19ae858e', component.options)
    } else {
      api.reload('19ae858e', component.options)
    }
    module.hot.accept("./ShiftHoursTab.vue?vue&type=template&id=19ae858e&scoped=true", function () {
      api.rerender('19ae858e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/settings/components/ShiftHoursTab.vue"
export default component.exports